import React, { Component } from "react";
import FacsimileDetailsPV from "./FacsimileDetailsPV";
import AuthA from "../../store/actions/AuthA";
import QuarterA from "../../store/actions/QuarterA";
import { Loader } from "semantic-ui-react";

import axios from "axios";
import sortBy from "lodash/sortBy";
import find from "lodash/find";
import isEmpty from "lodash/isEmpty";
import { connect } from "react-redux";
import { fetchData } from "../../utils/fetch-data";

import FacsimilePopup from "./FacsimilePopup";

const _ = {
  sortBy: sortBy,
  find: find,
  isEmpty: isEmpty,
};

class FacsimileDetailsPC extends Component {
  constructor(props) {
    super(props);
    this.state = {
      section: [],
      column: null,
      direction: null,
      sectionId: "",
      sectionSubjects: [],
      sectionStudent: null,
      summary: null,
      daysOfSchool: null,
      attendance: null,
      remarks: null,
      schoolYear: null,
      show: false,
      teachers: [],
      sectionStudents: [],
      sectionStudentId: "",
      clubStudents: [],
    };
    this.getSectionSubjects = this.getSectionSubjects.bind(this);
    this.getSectionStudent = this.getSectionStudent.bind(this);
    this.handleSort = this.handleSort.bind(this);
  }

  getSectionSubjects(sectionId) {
    fetchData(
      "/sectionSubjects?filter[where][active]=true&filter[include]=subject&filter[include]=teacher&filter[include]=details&filter[where][sectionId]=" +
        sectionId
    ).then((response) => {
      this.setState({ sectionSubjects: response.data });
    });
  }

  getSectionStudent(studentId) {
    fetchData(
      "/sectionStudents?filter[where][active]=true&filter[include]=student&filter[include]=section&filter[include]=classConducts&filter[where][sectionStudentId]=" +
        studentId
    ).then((response) => {
      this.setState(
        {
          sectionStudent: response.data[0],
          sectionStudentId: response.data[0].sectionStudentId,
        },
        () => {
          this.getStudentGrades(studentId);
          this.getStudentAttendance(response.data[0].sectionStudentId);
          this.getStudentRemarks(response.data[0].sectionStudentId);
          this.getStudentClubs(response.data[0].studentId);
        }
      );
    });
  }

  getSectionStudents(sectionId) {
    fetchData(
      "/sectionStudents?filter[where][active]=true&filter[include]=student&filter[where][sectionId]=" +
        sectionId
    ).then((response) => {
      this.setState({ sectionStudents: response.data });
    });
  }

  getStudentGrades = async (studentId) => {
    const currentQuarter = this.props.currentQuarter || 1;
    await fetchData(
      `/sectionStudents/summary/student/grade?quarter=${currentQuarter}&studentId=${studentId}`
    ).then((response) => {
      this.setState({ summary: response.data });
    });
  };

  getTeachers = async () => {
    const token = localStorage.getItem("token");

    await fetchData(`/teachers?access_token=${token}`).then((response) => {
      if (response) {
      
        
        this.setState({ teachers: response.data });
      }
    });
  };

  /**
   * The clubs this learner belongs to.
   *
   * Keyed on the STUDENT, not the section student: a club holds learners from
   * several grade levels, so it cannot hang off one section. The roster is
   * narrowed to the card's school year in clubMembership, since a club belongs
   * to a year and last year's membership must not print on this year's card.
   */
  getStudentClubs = (studentId) => {
    if (!studentId) return;
    fetchData(
      `/clubStudents?filter[where][active]=true&filter[include]=club&filter[where][studentId]=${studentId}`
    ).then((response) => {
      this.setState({ clubStudents: response ? response.data : [] });
    });
  };

  getStudentAttendance = (sectionStudentId) => {
    fetchData(
      `/attendances?filter[where][sectionStudentId]=${sectionStudentId}`
    ).then((response) => {
      this.setState({ attendance: response.data[0] });
    });
  };

  getStudentRemarks = (sectionStudentId) => {
    fetchData(
      `/classRemarks?filter[where][sectionStudentId]=${sectionStudentId}`
    ).then((response) => {
      this.setState({ remarks: response.data[0] });
    });
  };

  getDaysOfSchool = (id) => {
    fetchData("/schoolYears/" + id + "/days")
      .then((response) => {
        this.setState({
          daysOfSchool: response.data,
        });
      })
      .catch(function (error) {
        console.log(error);
      });

    fetchData("/schoolYears/" + id)
      .then((response) => {
        this.setState({
          schoolYear: response.data,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  openFacsimilePopup = () => {
    const {
      sectionStudent,
      sectionSubjects,
      daysOfSchool,
      summary,
      attendance,
      schoolYear,
    } = this.state;
    return (
      <FacsimilePopup
        sectionStudent={sectionStudent}
        sectionSubjects={sectionSubjects}
        daysOfSchool={daysOfSchool}
        summary={summary}
        attendance={attendance}
        schoolYear={schoolYear}
        onClose={() => this.setState({ show: false })}
      />
    );
  };

  handleOpen = () => {
    this.setState({ show: true });
  };

  handleShowFinalGradeAverage = (data, id) => {
    const url = `${process.env.REACT_APP_URL}/sectionStudents/` + id;
    axios
      .request({
        method: "put",
        url: url,
        data: data,
      })
      .then((response) => {
        alert(`Final Average Grade is now publicly displayed.`);
        this.getSectionStudent(response.data.sectionStudentId);
      })
      .catch((error) => {
        console.log(error);
        if (error.response) {
          alert(`${error.response.data.error.message}`);
        } else if (error.request) {
          alert(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          alert("Error. Please contact your administrator for assistance.");
        }
      });
  };

  // handlePopCard(data){
  //   const {
  //     sectionStudent, sectionSubjects, daysOfSchool, attendance, schoolYear
  //   } = this.state;
  //
  //   localStorage.setItem('sectionStudent', JSON.stringify(sectionStudent));
  //   localStorage.setItem('sectionSubjects', JSON.stringify(sectionSubjects));
  //   localStorage.setItem('daysOfSchool', JSON.stringify(daysOfSchool));
  //   localStorage.setItem('attendance', JSON.stringify(attendance));
  //   localStorage.setItem('schoolYear', JSON.stringify(schoolYear));
  //   window.open('/popup/facsimile', '_blank', 'toolbar=no,scrollbars=yes,resizable=yes,width=1000,height=550')
  // }

  handleSort(clickedColumn) {
    const { column, sectionSubjects, direction } = this.state;
    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        sectionSubjects: _.sortBy(sectionSubjects, [clickedColumn]),
        direction: "ascending",
      });
      return;
    }
    this.setState({
      sectionSubjects: sectionSubjects.reverse(),
      direction: direction === "ascending" ? "descending" : "ascending",
    });
  }

  handleChange = (e, { name, value }) => {
    if (name === "sectionId") {
      // this.setState({[name]: value}, () => this.getSectionStudents(value))
      this.props.history.push("/classes/" + value);
    } else if (name === "sectionStudentId") {
      this.props.history.push(
        "/facsimile/" +
          this.props.match.params.sectionId +
          "/" +
          value +
          "/" +
          this.props.match.params.schoolYearId
      );
    } else {
      this.setState({ [name]: value }, () => this.getSections(true, ""));
    }
  };

  componentDidMount() {
    this.props.authFn.getToken();
    this.props.quarterFn.initializeQuarter();
    this.props.onContentMount({ title: "School Setup / Facsimile" });
    const sectionId = this.props.match.params.sectionId;
    const studentId = this.props.match.params.studentId;
    const schoolYearId = this.props.match.params.schoolYearId;
    this.getSectionSubjects(sectionId);
    this.getSectionStudent(studentId);
    this.getDaysOfSchool(schoolYearId);
    this.getSectionStudents(sectionId);
    this.getTeachers();
  }

  componentDidUpdate = (prevProps) => {
    if (
      prevProps.match.params.studentId !== this.props.match.params.studentId
    ) {
      const sectionId = this.props.match.params.sectionId;
      const studentId = this.props.match.params.studentId;
      const schoolYearId = this.props.match.params.schoolYearId;
      this.getSectionSubjects(sectionId);
      this.getSectionStudent(studentId);
      this.getDaysOfSchool(schoolYearId);
      this.getSectionStudents(sectionId);
      this.getTeachers();
    }

    // Refresh student grades when quarter changes
    if (
      prevProps.currentQuarter !== this.props.currentQuarter &&
      this.props.match.params.studentId
    ) {
      this.getStudentGrades(this.props.match.params.studentId);
    }
  };

  render() {
    if (this.state.summary === null) return <Loader />;
    return (
      <React.Fragment>
        <FacsimileDetailsPV
          auth={this.props.auth}
          userType={this.props.userType}
          column={this.state.column}
          direction={this.state.direction}
          sectionId={this.state.sectionId}
          section={this.state.section}
          sectionStudent={this.state.sectionStudent}
          sectionSubjects={this.state.sectionSubjects}
          summary={this.state.summary}
          attendance={this.state.attendance}
          remarks={this.state.remarks}
          teachers={this.state.teachers}
          daysOfSchool={this.state.daysOfSchool}
          schoolYear={this.state.schoolYear}
          sectionStudents={this.state.sectionStudents}
          clubStudents={this.state.clubStudents}
          sectionStudentId={this.state.sectionStudentId}
          currentQuarter={this.props.currentQuarter}
          quarterFn={this.props.quarterFn}
          handleSort={this.handleSort}
          handleChange={this.handleChange}
          handleOpen={this.handleOpen}
          handleShowFinalGradeAverage={this.handleShowFinalGradeAverage}
        />
        {this.state.show && this.openFacsimilePopup()}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authFn: AuthA(dispatch),
    quarterFn: QuarterA(dispatch),
  };
};

const mapStateToProps = (state) => {
  return {
    auth: state.AuthR.auth,
    userId: state.AuthR.userId,
    userType: state.AuthR.userType,
    currentQuarter: state.QuarterR.currentQuarter,
    schoolYear: state.QuarterR.schoolYear,
    schoolYearId: state.QuarterR.schoolYearId,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FacsimileDetailsPC);
